@if (state$ | async; as state) {
  <!-- Loading State -->
  @if (state.loading) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Loading your applications...</p>
    </div>
  }
  <!-- No Applications State -->
  @else if (state.applications.length === 0) {
    <div class="flex flex-col items-center justify-center py-12 gap-4
                bg-white dark:bg-gray-800 rounded-lg shadow-md p-8">
      <mat-icon class="text-yellow-500 text-5xl" style="font-size: 48px; width: 48px; height: 48px;">
        warning
      </mat-icon>
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        No Applications Available
      </h3>
      <p class="text-gray-600 dark:text-gray-400 text-center max-w-md">
        You don't have access to any applications. Please contact your administrator
        if you believe this is an error.
      </p>
    </div>
  }

  <!-- Redirecting State -->
  @else if (!noRedirect && state.shouldRedirect && state.redirectTarget) {
    <div class="flex flex-col items-center justify-center py-12 gap-4">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="text-gray-700 dark:text-gray-300">Redirecting to primary application...</p>
    </div>
  }

  <!-- Applications Grid -->
  @else {
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      @for (app of state.applications; track app.id) {
        <app-application-tile [application]="app" />
      }
    </div>
  }
}
